import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import usePageTitle from "../../core/hooks/UsePageTitle";
import { AuthCard } from "../components/AuthCard/AuthCard";
import AssinanteService from "../../sdk/services/AssinanteService";

type Status = "loading" | "success" | "error";

export default function PaymentSuccessView() {
  usePageTitle("Pagamento confirmado");

  const navigate = useNavigate();
  const [status, setStatus] = useState<Status>("loading");
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    AssinanteService.getAssinatura()
      .then((sub) => {
        const isActive =
          sub && !sub.disabled && new Date(sub.validUntil!) > new Date();
        setStatus(isActive ? "success" : "error");
      })
      .catch(() => setStatus("error"));
  }, []);

  useEffect(() => {
    if (status !== "success") return;

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          navigate("/home");
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [status]);

  return (
    <AuthCard title="Pagamento">

      {/* Loading */}
      {status === "loading" && (
        <div className="text-center py-8">
          <div className="w-10 h-10 border-4 border-red-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Confirmando seu pagamento...
          </p>
        </div>
      )}

      {/* Success */}
      {status === "success" && (
        <div className="text-center py-4">
          <div className="text-6xl mb-5">🎉</div>
          <p className="text-slate-700 dark:text-slate-200 font-extrabold text-xl mb-1">
            Pagamento confirmado!
          </p>
          <p className="text-slate-500 dark:text-slate-400 text-sm mb-2">
            Bem-vindo ao Acertei Premium.
          </p>
          <p className="text-slate-400 dark:text-slate-500 text-xs mb-8">
            Redirecionando em{" "}
            <span className="font-bold text-red-600">{countdown}s</span>...
          </p>

          {/* Progress bar */}
          <div className="w-full bg-slate-100 dark:bg-slate-700 rounded-full h-1.5 overflow-hidden">
            <div
              className="h-1.5 bg-red-600 rounded-full transition-all duration-1000"
              style={{ width: `${((3 - countdown) / 3) * 100}%` }}
            />
          </div>
        </div>
      )}

      {/* Error — payment not yet reflected */}
      {status === "error" && (
        <div className="text-center py-4">
          <div className="text-5xl mb-5">⏳</div>
          <p className="text-slate-700 dark:text-slate-200 font-semibold text-lg mb-1">
            Processando pagamento
          </p>
          <p className="text-sm text-slate-500 dark:text-slate-400 mb-7 leading-relaxed">
            Seu pagamento está sendo processado. Aguarde alguns instantes e
            acesse a plataforma.
          </p>
          <button
            onClick={() => navigate("/home")}
            className="w-full py-2.5 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors duration-200"
          >
            Acessar plataforma
          </button>
        </div>
      )}

    </AuthCard>
  );
}
